export default [
  {
    path: '/kys-istek-sikayet',
    name: 'kys-istek-sikayet',
    component: () => import('./Index.vue'),
    meta: {
      public: false,
      title: "kys_istek_sikayet.Baslik",
      yetki: { k: [1190302] },
    },
  },
  {
    path: '/kys-istek-sikayet/ekle',
    name: 'kys-istek-sikayet-ekle',
    component: () => import('./Create.vue'),
    meta: {
      public: false,
      title: "kys_istek_sikayet.Yeni_Kayit",
      yetki: { k: [1190303] },
    },
  },
  {
    path: '/kys-istek-sikayet/detay/:uuid',
    name: 'kys-istek-sikayet-detay',
    component: () => import('./Detail.vue'),
    meta: {
      public: false,
      title: "kys_istek_sikayet.Detay",
      yetki: { k: [1190302] },
    },
  },
]
